import React from 'react';
import PropTypes from 'prop-types';
var TabList = function TabList(_ref) {
  var children = _ref.children,
    changeTab = _ref.changeTab,
    activeTab = _ref.activeTab,
    className = _ref.className;
  var childrenWithProps = React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      changeTab: changeTab,
      activeTab: activeTab
    });
  });
  return React.createElement('div', {
    className: className
  }, childrenWithProps);
};
process.env.NODE_ENV !== "production" ? TabList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  changeTab: PropTypes.func,
  activeTab: PropTypes.string,
  className: PropTypes.string
} : void 0;
export default TabList;